export default "__VITE_ASSET__cf5e5790__"